import { memo, ReactNode } from 'react';
import classes from 'classnames';
import Card from '@/components/Card/Card';
import styles from './RadioCard.module.scss';

export type Props = {
  id?: string;
  className?: string;
  checked?: boolean;
  name?: string;
  dataTest?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  children?: ReactNode;
};

const RadioCardMemo = memo(function RadioCard({
  id,
  className,
  checked,
  name,
  dataTest = 'radioCard',
  onChange,
  value,
  children,
}: Props) {
  return (
    <Card
      className={classes(
        styles.container,
        checked && styles.checked,
        className,
      )}
      dataTest={dataTest}
    >
      <input
        className={styles.input}
        id={id}
        onChange={onChange}
        value={value}
        type="radio"
        name={name}
        checked={checked}
        data-test={`${dataTest}-input`}
      />
      <div className={styles['checkmark-container']}>
        <div className={classes(styles.checkmark, checked && styles.checked)}>
          {checked && (
            <div
              className={styles['checkmark-filled']}
              data-test={`${dataTest}-checked`}
            />
          )}
        </div>
      </div>
      <div className={styles.content} data-test={`${dataTest}-content`}>
        {children}
      </div>
    </Card>
  );
});

export default RadioCardMemo;
